// @ts-ignore
import React from "react";
import LoadingIcon from "../../assets/svg/loading.svg";

const Loader = ({
  align = "left",
  text = "Loading, please wait...",
  showText = true,
  noLeftMargin = false,
  forceFullWidth = false,
  center = false,
}: {
  align?: "left" | "center";
  text?: string;
  showText?: boolean;
  noLeftMargin?: boolean;
  forceFullWidth?: boolean;
  center?: boolean;
}) => {
  return (
    <div
    id="loader"
    className={center 
      ? `flex flex-col items-center justify-center h-screen ${forceFullWidth ? 'w-full' : ''}`
      : `loader__${align} ${!showText && "loader__notext"} ${
          noLeftMargin && "loader__noleftmargin"
        } ${forceFullWidth && "loader__fullwidth"}`
    }>
      <div className={center ? "flex items-center justify-center mb-2" : "loader__icon"}>
        <object
        width="40"
        height="40"
        type="image/svg+xml"
        data={LoadingIcon}
        aria-label="Loading" />
      </div>

      {showText && <p className={center ? "text-center !text-[#9fafb5]" : "loader__text !text-[#9fafb5]"}>{text}</p>}
    </div>
  );
};

export default Loader;
